import React from 'react';
import { TransactionTable } from './components/table/TransactionsTable';
import { useTransactionUpdateNotification } from '../../components/useTransactionUpdateNotification';
import { TransactionsTableToolbar } from './components/table/TransactionsTableToolbar';
import { CurrencyDisclaimerPopup } from '../../components/popup/currencyDisclaimerPopup/CurrencyDisclaimerPopup';

export const TransactionPage: React.FC = () => {
  useTransactionUpdateNotification();

  return (
    <>
      <TransactionsTableToolbar />
      <TransactionTable />
      <CurrencyDisclaimerPopup />
    </>
  );
};
